import RecordableView from '@/template/views/RecordableView.vue';
import BasicInfoView from '@/template/components/investmentReport/BasicInfoView.vue';
import FinancesView from '@/template/components/investmentReport/FinancesView.vue';
import ContactInfoView from '@/template/components/shared/ContactInfoView.vue';
import { InvestmentReportType } from '@/common/types/InvestmentReportType';
import { BAidType } from '@/common/types/BAidType';
var titleKey = function (investmentReport) { return "InvestmentReport." + InvestmentReportType[investmentReport.reportType]; };
var instructionLinksFactory = function (configuredLinks, languageCode, investmentReport) {
    var type = null;
    switch (investmentReport.bAidType) {
        case BAidType.ICTAndFixedAssets:
            type = "ICT";
            break;
        case BAidType.PremisesRenovationOrImprovement:
            type = "premises";
            break;
        case BAidType.SupportApartments:
            type = "supportApartments";
            break;
    }
    return {
        id: "investmentReport",
        type: type,
        metaType: InvestmentReportType[investmentReport.reportType].toString()
    };
};
var basicInfo = function (report) {
    return {
        basicInfo: report.basicInfo,
        bAidType: report.bAidType,
        reportType: report.reportType
    };
};
var finances = function (report) {
    return {
        finances: report.finances,
        bAidType: report.bAidType,
        reportType: report.reportType
    };
};
var contactInfo = function (report) {
    return {
        budgetaryEstimate: report.contactInfo
    };
};
export var route = {
    path: '/investmentReport/:id',
    component: RecordableView,
    props: {
        titleKey: titleKey,
        recordableType: "InvestmentReport",
        instructionLinksFactory: instructionLinksFactory,
        multipleSections: true
    },
    children: [
        {
            name: 'investmentReport',
            path: '',
            component: BasicInfoView,
            meta: {
                title: 'InvestmentReport.Menu.BasicInfo',
                section: 1,
                props: basicInfo,
                deletable: false
            }
        },
        {
            name: 'investmentReport-finances',
            path: 'finances',
            component: FinancesView,
            meta: {
                title: 'InvestmentReport.Menu.Finances',
                section: 2,
                props: finances,
                deletable: false
            }
        },
        {
            name: 'investmentReport-contact-info',
            path: 'contactInfo',
            component: ContactInfoView,
            meta: {
                title: 'Menu.ContactInfo',
                section: 3,
                props: contactInfo,
                deletable: false
            }
        }
    ]
};
